import api from "api/api";
import { CORRESPONDENCE_TABLE_CSLT_STR_FILTER_OPTIONS } from "constants/constants";
import { formatDateToYYYYMMDD } from "utils/formatters";
import { cleanUrl } from "utils/helper";

export const getDashboardBillingStatisticsQuery = async ({ scope, year }) =>
  await api.get(`/dashboard/billing/statistics?scope=${scope}&year=${year}`);

export const getDashboardBarChartQuery = async ({
  scope,
  page,
  per_page,
  date,
  signed_by,
  charged_by,
  mission_type,
  client,
}) => {
  const queryString = cleanUrl({
    scope,
    date,
    mission_signed_by: signed_by,
    mission_charged_by: charged_by,
    mission_type,
    client,
  });
  return await api.get(
    `dashboard/diagram/bar/?page=${page}&per_page=${per_page}&${queryString}`
  );
};

export const getBarChartExportQuery = async ({
  scope,
  date,
  signed_by,
  charged_by,
  mission_type,
  client,
  lang,
}) => {
  const queryString = cleanUrl({
    scope,
    date,
    mission_signed_by: signed_by,
    mission_charged_by: charged_by,
    mission_type,
    client,
    lang,
  });
  return api.getBlob(`dashboard/diagram/bar/export?${queryString}`);
};

export const getDashboardICQuery = async ({ scope, date, page, signed_by }) => {
  // A consultant on the bench has no mission: the relevant branch is the one
  // they are assigned to, not the one that would have signed a deal.
  const queryString = cleanUrl({ assigned_branch_ids: signed_by });
  return await api.get(
    `dashboard/ic/?scope=${scope}&date=${date}&items_per_page=15&page=${page}${
      queryString ? `&${queryString}` : ""
    }`
  );
};

export const getIcExportQuery = async ({ scope, date, lang }) => {
  return api.getBlob(
    `/dashboard/ic/export?scope=${scope}&date=${date}&lang=${lang}`
  );
};

export const getCorrespondenceTableHashQuery = async ({
  exportCa,
  workerType,
  startDate,
  endDate,
  scope,
}) => {
  const exportCaParam = `export_ca=${exportCa}`;
  const workerTypeParam =
    workerType &&
    workerType !== CORRESPONDENCE_TABLE_CSLT_STR_FILTER_OPTIONS[2].value
      ? `&worker_type=${workerType}`
      : "";

  const url = `/timeline/correspondances/csv?${exportCaParam}${workerTypeParam}&start_date=${formatDateToYYYYMMDD(
    startDate
  )}&end_date=${formatDateToYYYYMMDD(endDate)}&scope=${scope}`;

  return api.post(url);
};

export const getCorrespondenceTableExportQuery = async ({ file_id }) => {
  return api.getBlob(`/file/${file_id.uri}`);
};
